<script >
import { ref, computed } from 'vue-demi';
import useTabHeaderBar from './useTabHeaderBar';
import TabHeaderTitle from './tab-header-title.vue';
const __sfc_main = {};
__sfc_main.props = {
  tpl: Object,
  value: {},
  resizable: Boolean
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emits = __ctx.emit;
  const activeId = computed(() => props.value);
  const activeChild = computed(() => props.tpl.children.find(i => {
    return i.id === activeId.value;
  }) || props.tpl.children[0]);
  const clickMe = v => emits('setActive', v.id);

  // tab滑块逻辑
  const headerRef = ref();
  const {
    headerActiveBarStyle
  } = useTabHeaderBar({
    headerRef,
    activeId,
    resizable: props.resizable
  });
  return {
    activeChild,
    clickMe,
    headerRef,
    headerActiveBarStyle
  };
};
__sfc_main.components = Object.assign({
  TabHeaderTitle
}, __sfc_main.components);
export default __sfc_main;
</script>
<template>
    <!-- tab头部吸顶-->
    <div class="vertical-anchor-tab-header">
        <div class="vertical-anchor-tab-header-real" ref="headerRef">
            <a
                v-for="item of tpl.children"
                href="javascript:void(0)"
                :key="'part' + item.id"
                class="vertical-anchor-tab-part"
                @click="clickMe(item)"
                :class="{ active: activeChild === item }"
            >
                <TabHeaderTitle :title="item.props.title"></TabHeaderTitle>
            </a>
            <div class="vertical-anchor-tab-header-active-bar" :style="headerActiveBarStyle"></div>
        </div>
    </div>
</template>
<style scoped lang="less">
@import '../common.less';
</style>
